var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCooperativeSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3064_71410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94043 4.625H4.94793M4.94043 13.625H4.94793M3.44043 1.625H15.4404C16.2689 1.625 16.9404 2.29657 16.9404 3.125V6.125C16.9404 6.95343 16.2689 7.625 15.4404 7.625H3.44043C2.612 7.625 1.94043 6.95343 1.94043 6.125V3.125C1.94043 2.29657 2.612 1.625 3.44043 1.625ZM3.44043 10.625H15.4404C16.2689 10.625 16.9404 11.2966 16.9404 12.125V15.125C16.9404 15.9534 16.2689 16.625 15.4404 16.625H3.44043C2.612 16.625 1.94043 15.9534 1.94043 15.125V12.125C1.94043 11.2966 2.612 10.625 3.44043 10.625Z",
    stroke: "#590DA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3064_71410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.44043 0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperativeSettings);
export default __webpack_public_path__ + "static/media/CooperativeSettings.856dd2c98e5078e4da113909ea218dc6.svg";
export { ForwardRef as ReactComponent };